// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, Fragment, useContext, useEffect, useRef,
    useState, useMemo} from 'react';
import {Link} from '../link';
import cn from 'classnames';
import {use_theme} from '../../settings_ctx';
import {img_url} from '../img_url';
import {use_navbar} from './use_navbar';
import {Agree_dialog} from '../../shared/agree_dialog/agree_dialog';
import {Install_btn} from '../install_btn';
import {logout} from './nav_utils';
import styles from './mobile_nav.module.less';
// @ts-ignore
import {App_context} from '../../context.js';
import storage from '/util/storage.js';
import {useLocation} from 'react-router-dom';
import Icon_cart from '../../img/hola2023/icons/24/cart.svg';
import {use_qs_with_set} from '../../lib/use_qs';
import {use_login} from './use_login';
// import {use_premium_page} from '../premium/use_premium_page';
// import zcountry, {format_price} from 'zcountry';
import zcountry from 'zcountry';
import {Svg_img} from '../svg_img';
import {use_countries} from '../forms/use_countries';
import {Button} from '../../../../shared/button';

interface i_links_group_props {
    title: string | JSX.Element;
    items?: {title: string | JSX.Element; to: string; new_tab?: boolean}[];
    on_click?: ()=>void;
    on_expand?: ()=>void;
    cls?: string;
    title_icon?: JSX.Element;
}
const Links_group = (props: i_links_group_props)=>{
    const {title, items, on_click, on_expand, cls, title_icon} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const [expanded, set_expanded] = useState(false);
    const [style, set_style] = useState<CSSProperties>({});
    const list_ref = useRef<HTMLUListElement>();
    useEffect(()=>{
        if (!list_ref.current)
            return;
        const calc_style = ()=>{
            const b = list_ref.current.getBoundingClientRect();
            set_style({'--expander_height': `${b.height}px`} as CSSProperties);
        };
        calc_style();
        window.addEventListener('resize', calc_style);
        return ()=>{
            window.removeEventListener('resize', calc_style);
        };
    }, [list_ref.current]);
    const group_cls = cn(styles.links_group, cls, expanded && styles.expanded);
    return <div className={group_cls} style={style}>
      <p className={cn(theme.p1, theme.bold, styles.title)}
        onClick={()=>{
          set_expanded(v=>!v);
          if (on_expand)
            on_expand();
        }}>
        {title}
        {title_icon || <Svg_img w={24} h={24}
          id={'hola2023/icons/16/chevron_down.svg'} cls={styles.title_icon} />}
      </p>
      {items && <ul ref={list_ref}>
        {items.map(l=>{
            return <li key={l.to}>
              <Link to={l.to} className={cn(theme.P, theme.p1)}
                onClick={on_click} data-clickid={l.to}
                target={l.new_tab ? '_blank' : undefined}
                rel={l.new_tab ? 'noopener noreferrer' : undefined}>
                {l.title}
              </Link>
            </li>;
        })}
      </ul>}
    </div>;
};

const logo_links = {
    '/affiliate_frm': {to: '/pricing/premium?ref=affiliate_frm',
        target: '_blank', rel: 'noopener noreferrer'},
    '/download_ie': {to: null},
};

const Hola_mobile_nav = (props: ReturnType<typeof use_navbar>)=>{
    const {theme} = use_theme({def: 'hola2023'});
    // const {has_user, is_plus,user_country, nologin,
    const {has_user, user_country, nologin,
        toggle, nav_opt, no_getstarted, cp_link, cp_after_login,
        with_cart, headlogo, nomenu} = props;
    // const {opt: {plans, currency}} = use_premium_page({from_bext: false,
    //     from_nav_bar: true});
    const {countries} = use_countries('f32', cn(styles.flag_wrap,
        theme.xs, theme.P), styles.flag_icon, null, null, true);
    const on_toggle = ()=>{ toggle(); };
    const on_logout = event=>{
        event.preventDefault();
        logout();
    };
    const link_cls = cn(theme.p1, theme.bold, styles.link);
    const start_btn_cls = cn('hola_btn hola_btn--xs hola_btn--round',
        'hola_btn--txt_colored hola_btn--no_jump hola_btn-no_arrow');
    const install_btn_cls = cn('hola_btn hola_btn--lg hola_btn--round',
        'hola_btn--txt_colored hola_btn--no_jump');
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const logo_and_login = !!nav_opt?.logo_and_login;
    const show_nav_menu = is_client && !headlogo && !nomenu &&
      !logo_and_login;
    // XXX: defined in vpn_config
    // why: there is link to open /faq
    // we have to go back to /vpn_config
    const {pathname, search} = useLocation();
    const global_homepage = is_client ? storage.get('global_homepage') : '';
    const link_props = global_homepage ? {to: global_homepage} :
        logo_links[pathname] || {to: '/'};
    if (link_props && link_props.to=='/vpn_config'
        || search && search.indexOf('logo_disabled')>-1)
    {
        link_props.to = '';
    }
    const logo = nav_opt?.logo || 'hola_logo_letters.svg';
    const img_url_fn = nav_opt?.img_url_fn || img_url;
    const custom_logo = !!nav_opt?.logo;
    const {set_qs} = use_qs_with_set();
    const {on_login} = use_login(cp_after_login, cp_link);
    /*
    const plans_for_ui = useMemo(()=>plans.filter(p=>p.id!=='free')
      .map((p, i)=>{
      const link = `https://hola.org/premium?ref=navbar`+
          `&plan=${p.period.replace(' ', '').toLowerCase()}`;
      const best = 'josh_3y';
      const plan = p.currency && p.currency[currency.toLowerCase()]||p;
      return {title: <Fragment key={p.id}>
        <div className={cn(styles.plan, p.id==best && styles.plan_best)}>
          <div className={cn(styles.plan_wrapper)}>
          <div className={cn(theme.H5, theme.color_n700, styles.plan_month)}>
            {format_price(currency, plan.month_price)}
            <span> / month</span>{p.id==best &&
              <span className={styles.best}>best value</span>}</div>
          <div className={styles.plan_occurrence}>
            {plan.regular_price && plan.regular_price!==plan.price &&
            <div className={styles.regular_price_wrapper}>
              <span className={styles.plan_regular_price_crossed}>
                {format_price(currency, plan.regular_price)}</span>
              <span className={styles.plan_regular_price}> {format_price(
                currency, plan.price)}</span>
            </div>}
            billed every {plan.every}</div>
          </div>
          <Svg_img w={24} h={24} id={'hola2023/icons/16/chevron_right.svg'} />
          </div>
            {i!==plans.filter(pl=>pl.id!=='free').length - 1 &&
              <div className={styles.plan_separator}>&nbsp;</div>}
      </Fragment>, to: link};
    }), [plans]);
    */
    const countries_for_ui = useMemo(()=>{
      const filtered_countries = countries.filter(c=>/US|GB|MX/.test(c.value))
        .map((c, i)=>{
          return {title: <Fragment key={i}>
            <div className={styles.location_wrapper}>
              <div className={styles.location}>
                {c.rendered_item} {c.title}
              </div>
              <Svg_img w={24} h={24}
                id={'hola2023/icons/16/chevron_right.svg'}/>
            </div>
            {i!==countries.filter(ct=>/US|GB|MX/.test(ct.value)).length - 1 &&
              <div className={styles.plan_separator}>&nbsp;</div>}
          </Fragment>, to: 'https://hola.org/vpn/'+
            zcountry.code2hiphen_label(c.value)};
        });
      return [...filtered_countries, {title:
        <Button caption={<div>Check all locations <Svg_img w={20} h={20}
          id={'hola2023/icons/16/chevron_right.svg'}/></div>}
          cls={styles.locations_button} color="transparent"
          arrow={true} w100={true}/>, to: 'https://hola.org/vpn/'}];
    }, [countries]);
    return <>
      <Link {...link_props} className={cn(styles.logo,
        custom_logo && styles.auto_height,
        'logo_global_class')} data-clickid="nav_mobile_logo">
        <img src={img_url_fn(logo)} alt="logo" className="lazyload"/>
      </Link>
      <div className={styles.menu}>
        {logo_and_login ? <div className={styles.icons}>
          <Link to={cp_link||'/cp'} data-clickid="login"
            className={styles.profile}
            onClick={has_user ? undefined : on_login}>
            <Svg_img w={24} h={24} id={'hola2023/icons/24/user_circle.svg'}/>
          </Link>
        </div> : nav_opt.login_icon_mobile && <div
          className={styles.icons}>
          <Link to={cp_link||'/cp'} data-clickid="login"
            className={styles.profile}
            onClick={has_user ? undefined : on_login}>
            <Svg_img w={24} h={24} id={'hola2023/icons/24/user_circle.svg'}/>
          </Link>
        </div>}
        {show_nav_menu && <div className={styles.icons}>
          {has_user && !nologin ? <Link to={cp_link||'/cp'} data-clickid="cp"
            className={styles.profile}><Svg_img w={24} h={24}
              id={'hola2023/icons/24/user_circle.svg'}/>
          </Link> : <Fragment>
            {no_getstarted ? null : <div className={styles.start}>
              <Install_btn src="nav_mobile_start" user_country={user_country}
                className={start_btn_cls} agree_dialog={Agree_dialog}
                text="Get started" keep_btn_text/>
            </div>}
          </Fragment>}
          <div className={styles.burger} onClick={on_toggle}>
            <Svg_img h={24} w={24} cls={styles.icon_menu}
              id={'hola2023/icons/24/menu.svg'}/>
            <Svg_img h={24} w={24} cls={styles.icon_close}
              id={'hola2023/icons/16/x_close.svg'}/>
          </div>
        </div>}
        {!logo_and_login && <div className={styles.links_wrapper}>
          <div className={cn(theme.container, styles.links)}>
            {!has_user && !nologin && <Link to={'/signin'
              + (cp_after_login ? `?next=${cp_link||'/cp'}` : '')}
              className={link_cls} data-clickid="nav_mobile_login"
              onClick={on_toggle}>Log in</Link>}
            {/* {!is_plus && <Links_group title="Premium" items={plans_for_ui}
              cls={styles.no_justify} on_click={on_toggle}/>} */}
            <Link to="/products/discover" className={link_cls}
              data-clickid="nav_mobile_discover" onClick={on_toggle}>
              Discover Hola Products
            </Link>
            <Links_group title="VPN Locations" items={countries_for_ui}
              cls={styles.no_justify} on_click={on_toggle}/>
            <Links_group title="Support" items={[
              {title: 'Help center', to: 'https://support.hola.org'},
              {title: 'Troubleshooting', to: 'https://support.hola.org/'+
                'collections/9875490-troubleshooting'}
              // {title: 'Report a problem',
              //   to: 'https://hola.org/premium_support'},
            ]} on_click={on_toggle}/>
            {has_user && !nologin && <a onClick={on_logout}
              data-clickid="mobile_nav_logout">
              <span className={link_cls}>Log out</span>
            </a>}
            <Install_btn src="nav_mobile_install" user_country={user_country}
              className={install_btn_cls} agree_dialog={Agree_dialog}/>
          </div>
        </div>}
        {!logo_and_login && with_cart && <div className={styles.cart_icon}>
          <Icon_cart onClick={()=>{
            set_qs({with_cart: 'true'});
          }}/>
        </div>}
      </div>
    </>;
};

export const Mobile_nav = (props: ReturnType<typeof use_navbar>)=>{
    const {is_scrolled, opened, nav_opt} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const nav_cls = cn(styles.mobile_nav, theme.root, {
        [styles.scrolled]: is_scrolled,
        [styles.opened]: opened,
        [styles.transparent]: nav_opt?.transparent,
    });
    // XXX dmitriiz: use logo_global_class only for temporary reason,
    // such as experiments
    return <div className={nav_cls}>
      <div className={cn(theme.container, styles.container)}>
        <Hola_mobile_nav {...props}/>
      </div>
    </div>;
};
